import _ from 'lodash';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link } from 'react-router';
import * as actions from '../../actions/eventActions';
import * as perm from '../../permission';
import EventDeadlines from '../../components/event/EventDeadlines';
import HeaderImage from '../../components/common/HeaderImage';
import RichDescription from '../../components/common/RichDescription';
import DateTimeFormatter from '../../components/DateTimeFormatter';
import Loading from '../../components/Loading';
import Button from '../../components/common/Button';
import PermissionLink from '../../components/common/PermissionLink';

class ViewEvent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.regUrl = this.regUrl.bind(this);
    this.calcAvailableClub = this.calcAvailableClub.bind(this);
  }

  deleteEvent(e) {
    if (!confirm('Bekreft at du ønsker å slette dette arrangementet.')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.deleteEvent(this.props.eventDetails.id);
  }

  regUrl() {
    const details = this.props.eventDetails;
    const user = this.props.currentUser;
    let regUrl = '/arrangement/'+ details.id +'/registrer';
    let adminPermission = perm.hasPermission(user, ['super_admin'], this.props.eventDetails, 'write');
    if (!adminPermission && _.size(user.clubs) == 1) {
      regUrl = '/arrangement/'+ details.id +'/registrer/klubb/' +
        user.clubs[0].id + '/info';
    }
    return regUrl;
  }

  calcAvailableClub(details) {
    return Math.max(0, details.max_clubs - details.registered_clubs);
  }

  render() {
    let details = this.props.eventDetails;
    let signUpBtnClass = "btn btn-block btn-lg";
    if(this.props.loading) {
      signUpBtnClass += ' disabled btn-default';
    } else {
      signUpBtnClass += ' btn-primary';
    }
    let addressExtra = [
      details.venue_address,
      details.venue_zip,
      details.venue_municipality,
      details.venue_county,
      details.venue_country
    ].filter((item) => {return Boolean(item);});
    return (
      <div className="event-page-container container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
            <div className="panel panel-default">
              <HeaderImage
                headerLink={details.image}/>
              <div className="panel-body">
                <h2 className="page-header event-page-title">
                  {details.name}
                  <Loading loading={this.props.loading} />
                </h2>
                <div className="event-dureation">
                  <div className="row">
                    <div className="col-sm-6">
                      <DateTimeFormatter
                        value={details.start_date}
                        title="Startdato: "
                        hide={false} />
                    </div>
                    <div className="col-sm-6">
                      <DateTimeFormatter
                        value={details.end_date}
                        title="Sluttdato: "
                        hide={false} />
                    </div>
                  </div>
                </div>
                <Loading loading={this.props.loading} />
                <RichDescription description={details.description} />
                <PermissionLink
                  permission={true}
                  faName={""}
                  to={this.regUrl()}
                  className={signUpBtnClass}>
                  Til påmeldingskjema
                </PermissionLink>
                <h3 className="page-header">
                  Frister og billettinformasjon
                </h3>
                <EventDeadlines details={details} />
                <hr/>
                <div className="row">
                  <div className="col-sm-6">
                    <strong>
                      {'Maks. antall klubber: '+
                        (details.max_clubs || 'Ingen begrensning')}
                    </strong>
                    <br/>
                    <strong>{'Ledige plasser: '+ this.calcAvailableClub(details)}
                    </strong>
                  </div>
                  <div className="col-sm-6">
                    <strong>
                      {'Antall deltagere pr. klubb: '+
                        (details.max_contenders || 'Ingen begrensning')}
                    </strong>
                  </div>
                </div>
                <h3 className="page-header">
                  Sted
                </h3>
                <div className="vcard">
                  <p className="adr">
                    <strong>{details.venue_name}</strong><br/>
                    <span className="street-address">{addressExtra.join(", ")}</span>
                    <br/>
                  </p>
                </div>
              </div>
              <div className="panel-footer clearfix">
                <Link className="btn btn-default"
                  to={'/'}>
                  Tilbake
                </Link>
                <span className="pull-right">
                  <Button
                    permission={details.permissions.write}
                    className="btn btn-danger"
                    onClick={this.deleteEvent}
                    faName="trash">
                    {' Slett'}
                  </Button>
                  {' '}
                  <PermissionLink
                    permission={details.permissions.write}
                    to={'/arrangement/'+ details.id +'/rapporter'}
                    faName="table"
                    className="btn btn-default">
                    {' Rapporter'}
                  </PermissionLink>
                  {' '}
                  <PermissionLink
                    permission={details.permissions.write}
                    to={'/arrangement/'+ details.id +'/rediger'}
                    faName="edit"
                    className="btn btn-default">
                    {' Rediger'}
                  </PermissionLink>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ViewEvent.propTypes = {
  actions: PropTypes.object.isRequired,
  eventDetails: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  eventDetailsUpdated: PropTypes.number.isRequired,
  eventId: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    eventId: ownProps.params.eventId,
    currentUser: state.users.currentUser,
    loading: state.events.loadingEvents,
    eventDetails: state.events.eventDetails,
    eventDetailsUpdated: state.events.eventDetailsUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewEvent);



/** WEBPACK FOOTER **
 ** ./src/containers/events/ViewEvent.js
 **/